import React from 'react'
import PropTypes from 'prop-types'
import { Circles } from 'react-loader-spinner'

function CommonBtn({ isProgressBtn, isIconBtn, icon, className, value, style, onClick, textRight, textLeft, type, disabled, loadingIcon }) {
    if (isProgressBtn) {
        return (
            <button onClick={onClick} type={type ? type : 'button'} className={className} style={style} disabled={disabled}>{value}{loadingIcon ? <> &nbsp;<span className='d-inline-block align-middle ms-2'><Circles
                height="20"
                width="20"
                color="#fff"
                ariaLabel="circles-loading"
                visible={true}
            /></span></> : null}</button>
        )
    } else if (isIconBtn) {
        return (
            <button onClick={onClick} type={type ? type : 'button'} className={className} style={style} disabled={disabled}>{textLeft ? textLeft + ' ' : ''}{icon}{textRight ? ' ' + textRight : ''}{loadingIcon ? <> &nbsp;<span className='d-inline-block align-middle ms-2'><Circles
                height="20"
                width="20"
                color="#fff"
                ariaLabel="circles-loading"
                visible={true}
            /></span></> : null}</button>
        )
    } else {
        return (
            <button onClick={onClick} type={type ? type : 'button'} className={className} style={style} disabled={disabled}>{value}{loadingIcon ? <> &nbsp;<span className='d-inline-block align-middle ms-2'><Circles
                height="20"
                width="20"
                color="#fff"
                ariaLabel="circles-loading"
                visible={true}
            /></span></> : null}</button>
        )
    }

}

CommonBtn.propTypes = {
    value: PropTypes.string,
    className: PropTypes.string,
    isProgressBtn: PropTypes.bool,
    isIconBtn: PropTypes.bool,
    style: PropTypes.object,
    onClick: PropTypes.func,
    icon: PropTypes.element,
    textRight: PropTypes.string,
    textLeft: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    loadingIcon: PropTypes.bool,
}

CommonBtn.defaulProps = {
    value: '',
    className: 'btn',
    isProgressBtn: false,
    isIconBtn: false,
    style: {},
    onClick: () => { },
    icon: <></>,
    textRight: '',
    textLeft: '',
    type: 'button',
    disabled: false,
    loadingIcon: false,
}


export default CommonBtn